export default __webpack_public_path__ + "static/media/aug_banner.c8debace.png";